import React from 'react';
import { useTranslation } from 'react-i18next';
import Typography from '@material-ui/core/Typography';
import { SUPPORT_EMAIL, SUPPORT_PHONE } from '../../constants';
import MainButton from '../MUI/MainButton';
import useStyles from './useStyles';

const NeedMoreHelpSection = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <div className={classes.phoneContainer}>
        <Typography className={classes.phone}>
          <a className={classes.link} href={`tel:${SUPPORT_PHONE}`}>
            {SUPPORT_PHONE}
          </a>
        </Typography>
        <Typography className={classes.phoneText}>{t('home.supportCenter')}</Typography>
      </div>
      <div className={classes.emailUsContainer}>
        <Typography className={classes.title}>{t('home.needMoreHelp')}</Typography>
        <MainButton
          variant="outlined"
          color="primary"
          className={classes.button}
          href={SUPPORT_EMAIL}
        >
          {t('home.emailUs')}
        </MainButton>
      </div>
    </div>
  );
};

export default NeedMoreHelpSection;
